import React, { Component } from 'react';
import __ from 'lodash';
import history from '../../../../history';
import { URL_AKM,CONFIG_API_BE } from '../../../../config';
import akmApi from '../../../../apis/akmApi';
import eduprimeApi from '../../../../apis/eduprimeApi';
import {Row, Col} from 'react-bootstrap';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { FormControl, FormHelperText, Input, InputLabel } from '@material-ui/core';
import Select from 'react-select';
import LoaderModal from '../../../modal/LoaderModal';

class AccountForm extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isLoading: false,
            showAlert: false,
            alertMessage: "Error...",
            modalForm: false,
            admin: this.props.location.state.admin,
            confirmPassword: "",
            dinasPemda: {},
            dinasDetail: [],
            selectedProvinsi: null,
            selectedKab: null,
            selectedJenjang: null,
            kabupaten: []
        }
    }

    async componentDidMount() {
        const {admin} = this.state;
        
        if(!__.isUndefined(admin.idAdmin)) {
            if(admin.idRole === 12 && admin.idDinasPemda !== null) {
                this.fecthDinasPemda(admin.idDinasPemda);
            }
        }
        document.getElementsByClassName('navbar')[0].style.visibility = 'hidden';
    }

    fecthDinasPemda = async(idDinasPemda) => {
        this.setState({isFetching: true})
        const response = await akmApi.get(URL_AKM.DINAS_PEMDA_GET_BY_ID,
            {params: { idDinasPemda : idDinasPemda }});
        if(response){           
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                const prov = this.props.location.state.provinsi.find(p => p.value == response.data.data.idProvinsi)
                this.setState({ selectedProvinsi: { value: prov.value, label: prov.label} })
                this.fetchKabupaten(prov.value);
                const {level} = this.props.match.params;
                if(level === 'DINDIK') {
                    this.fecthDinasDetails(idDinasPemda);                    
                } 
                if(level === 'DINAS') {
                    // const kab = this.state.kabupaten.find(p => p.value == response.data.data.idKabupatenKota)
                    // console.log('kab..', this.state.kabupaten)
                    
                }
            }            
            this.setState({isFetching: false})
        }
    }

    fecthDinasDetails = async(idDinasPemda) => {
        this.setState({isFetching: true})
        const response = await akmApi.get(URL_AKM.DINAS_DETAIL_GET_BY_ID_DINAS,
            {params: { idDinasPemda : idDinasPemda }});
        if(response){           
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){                
                let data = [], arrjenjang = [], jenjang = [];
                response.data.data.map(res => {
                    jenjang = res.kodeJenjangSekolah.split(',');
                    this.state.kabupaten.map(kab => {
                        if(res.idKabupatenKota == kab.value) {
                            const object = {'value': kab.value, 'label': kab.label }
                            data.push(object)
                        }
                    })
                })
                jenjang.map(j => { 
                    const object = { 'value': j,'label': j}
                    arrjenjang.push(object)
                })
                this.setState({selectedKab: data, selectedJenjang: arrjenjang})
            }            
            this.setState({isFetching: false})
        }
    }

    fetchKabupaten = async(idProvinsi) => {
        this.setState({isLoading: true, kabupaten: [], selectedKab: null})
        const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + idProvinsi);
        if(response){
            let data = [];
            if(response.status === 200){
                response.data.list_kab_kota.map(value => {
                    const object = {
                        'value': value.ID_KABUPATEN_KOTA,
                        'label': value.NAMA_KABUPATEN_KOTA
                    }
                    data.push(object)
                })
            }            
            this.setState({ kabupaten: data, isLoading: false})
        }
        
    }

    handleSubmit = async(e) => {
        e.preventDefault();
        let {admin, selectedProvinsi, selectedKab, selectedJenjang} = this.state;
        const {idRole,level} = this.props.match.params;
        if(admin.namaAdminUser === undefined || admin.namaAdminUser === '') return false;
        if(admin.usernameAdmin === undefined || admin.usernameAdmin === '') return false;
        if(admin.passwordAdmin !== this.state.confirmPassword) return false;
        if(level === 'DINDIK') {
            if(selectedKab === null || selectedJenjang === null ) return false;
        }
       
        admin = {...admin, 
            levelAdminUser: level,
            statusAdminUser: 1,
            idRole: idRole,
            kodeOwner: 'PRIME',
            kodeCabangPrime: 'HO'
        }       
        
        let dinasPemda = {
            idProvinsi: selectedProvinsi === null ? null : selectedProvinsi.value,
            idKabupatenKota: level === 'DINDIK' ? null : selectedKab.value,
            namaDinas: admin.namaAdminUser
        }

        this.postData(dinasPemda, admin, level, selectedKab, selectedJenjang);

    }

    handleBack() {
        history.push({
            pathname: '/mgtakun',
            state: {
                role: this.props.location.state.role
            }
        })
    }

    postData = async(dinasPemda, admin, level, selectedKab, selectedJenjang) => {
        this.setState({isFetching: true})
        const saveDinas = await akmApi.post(URL_AKM.POST_DINAS_PEMDA_SAVE, dinasPemda);        
        if(saveDinas){  
            if(saveDinas.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                const idDinas = saveDinas.data.data.idDinasPemda;
                        
                if(level === 'DINDIK') {
                    let dinasDetail = [];
                    let strJenjang = "";            
                    selectedJenjang.map(j => {                
                        strJenjang += j.value + ",";
                    })
                    selectedKab.map(v => {
                        let obj = { 
                            idKabupatenKota: v.value,
                            kodeJenjangSekolah: strJenjang === null ? null : strJenjang.substring(0, strJenjang.length - 1),
                            idDinasPemda: idDinas
                        }
                        dinasDetail.push(obj)
                    })

                    await akmApi.post(URL_AKM.POST_DINAS_DETAIL_SAVE, dinasDetail);
                }                
               
                admin = {...admin, idDinasPemda: idDinas}
                const saveAdmin = await akmApi.post(URL_AKM.POST_SAVE_ADMIN, admin);
                if(saveAdmin){
                    if(saveAdmin.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                        this.handleBack();
                    } else {
                        this.setState({ isFetching: false, 
                            showAlert: true, 
                            alertMessage: 'Terjadi kesalahan atau Username sudah digunakan... please try again!!'
                        })
                    }            
                                
                }     
                
            } else {
                this.setState({ showAlert: true, alertMessage: 'Create Akun Gagal... Silakan Coba lagi' })
            }            
            this.setState({isFetching: false})            
        }    
    }

    onChangeNama = (event) => { 
        this.setState({ admin: {...this.state.admin, namaAdminUser: event.target.value} }) 
    }
    onChangeUsername = (event) => {
        this.setState({ admin: {...this.state.admin, usernameAdmin: event.target.value} }) 
    }
    onChangePassword = (event) => {
        this.setState({ admin: {...this.state.admin, passwordAdmin: event.target.value} }) 
    }
    onChangePassword2 = (event) => {
        this.setState({ confirmPassword: event.target.value }) 
    }
    onChangeTelepon = (event) => {
        this.setState({ admin: {...this.state.admin, telponAdmin: event.target.value} })  
    }
    onChangeEmail = (event) => {
        this.setState({ admin: {...this.state.admin, emailAdminUser: event.target.value} })  
    }
    handleChangeProvinsi = (data) => {
        this.setState({selectedProvinsi: data})
        this.fetchKabupaten(data.value)
    }
    handleChangeKabupaten = (data) => {
        this.setState({selectedKab: data})
    }
    handleChangeJenjang = (data) => {
        this.setState({selectedJenjang: data})
    }

    render() {
        const {admin} = this.state;
        const {idRole, level} = this.props.match.params;

        return(
            <div className="">
                <LoaderModal isFetching={this.state.isFetching}/> 
                
                <div className="container" style={{paddingBottom: '50px', paddingTop:'20px'}}>
                    

                    <Row>
                        <Col sm={8}>
                            <h2>Management Akun User {level}</h2>
                        </Col>
                       
                        <Col>
                            <Button className="pull-right" variant="outlined" color="secondary" onClick={() => {if (window.confirm('Konfirmasi Keluar ?')) this.handleBack()}}>
                                Batal &nbsp;<i className="fa fa-arrow-right"></i></Button>                                     
                        </Col>
                    </Row>
                   
                    {this.handleAlert()}

                    {idRole === "12" ?
                    <form noValidate onSubmit={this.handleSubmit}>     
                        <FormControl>
                            <InputLabel htmlFor="nama">Nama*</InputLabel>
                            <Input
                                error={admin.namaAdminUser === undefined || admin.namaAdminUser === "" ? true : false}
                                id="nama"
                                defaultValue={admin.namaAdminUser} 
                                onChange={this.onChangeNama}
                                required
                            />
                            {(admin.namaAdminUser === undefined || admin.namaAdminUser === "") &&
                            <FormHelperText className="text-danger">Incorrect entry...</FormHelperText>}
                        </FormControl> 

                        <FormControl>
                            <InputLabel htmlFor="username">Username*</InputLabel>
                            <Input
                                error={admin.usernameAdmin === undefined || admin.usernameAdmin === "" ? true : false}
                                id="username"
                                autoSave="false"
                                defaultValue={admin.usernameAdmin} 
                                onChange={this.onChangeUsername}
                                required
                            />
                            {(admin.usernameAdmin === undefined || admin.usernameAdmin === "") &&
                            <FormHelperText className="text-danger">Incorrect entry...</FormHelperText>}
                        </FormControl> 

                        <FormControl>
                            <InputLabel htmlFor="password">Password*</InputLabel>
                            <Input
                                error={admin.passwordAdmin === undefined || admin.passwordAdmin === "" ? true : false}
                                autoComplete="new-password"
                                autoSave="false"
                                type="password"
                                id="password"
                                defaultValue={admin.passwordAdmin} 
                                onChange={this.onChangePassword}
                                required
                            />
                            {(admin.passwordAdmin === undefined || admin.passwordAdmin === "") &&
                            <FormHelperText className="text-danger">Incorrect entry...</FormHelperText>}
                        </FormControl> 

                        <FormControl>
                            <InputLabel htmlFor="password2">Confirm Password*</InputLabel>
                            <Input 
                                error={ this.state.confirmPassword !== admin.passwordAdmin ? true : false}
                                type="password"
                                id="password2"
                                defaultValue={this.state.confirmPassword} 
                                onChange={this.onChangePassword2}
                                required
                            />
                            {( this.state.confirmPassword !== admin.passwordAdmin) &&
                            <FormHelperText className="text-danger">Password did not matched...</FormHelperText>}
                        </FormControl>                     
                        
                        <FormControl>
                            <InputLabel htmlFor="telepon">No. Telepon</InputLabel>
                            <Input
                                type="number"
                                id="telepon"
                                defaultValue={admin.telponAdmin} 
                                onChange={this.onChangeTelepon}                                
                            />                            
                        </FormControl> 

                        <FormControl>
                            <InputLabel htmlFor="email">Email</InputLabel>
                            <Input
                                type="email"
                                id="email"
                                defaultValue={admin.emailAdminUser} 
                                onChange={this.onChangeEmail}                                
                            />                            
                        </FormControl>   

                        <FormControl style={{marginTop: '15px'}}>  
                        <Row>
                            <Col>
                                <Select
                                    className="basic-single"
                                    placeholder ="Pilih Provinsi..."
                                    classNamePrefix="select"
                                    value={this.state.selectedProvinsi}
                                    isSearchable={true}
                                    name="provinsi"
                                    options={this.props.location.state.provinsi}
                                    onChange={this.handleChangeProvinsi}
                                /> 
                                {this.state.selectedProvinsi === null &&     
                                <FormHelperText className="text-danger">Incorrect entry...</FormHelperText> }
                            </Col>

                            <Col>
                                <Select isMulti={level === 'DINDIK' ? true : false}
                                    className="basic-single"
                                    placeholder ="Pilih Kabupaten..."
                                    classNamePrefix="select"
                                    value={this.state.selectedKab}
                                    isLoading={this.state.isLoading}
                                    isSearchable={true}
                                    name="provinsi"
                                    options={this.state.kabupaten}
                                    onChange={this.handleChangeKabupaten}
                                />  
                                {this.state.selectedKab === null &&     
                                <FormHelperText className="text-danger">Incorrect entry...</FormHelperText> }
                            </Col>
                        </Row>                   
                        </FormControl>    

                        {level === 'DINDIK' && <FormControl style={{marginTop: '15px'}}>  
                        <Row>
                            <Col sm={6}>
                                <Select isMulti
                                    className="basic-single"
                                    placeholder ="Pilih Jenjang..."
                                    classNamePrefix="select"
                                    value={this.state.selectedJenjang}
                                    isSearchable={true}
                                    name="jenjang"
                                    options={this.props.location.state.kodeJenjang}
                                    onChange={this.handleChangeJenjang}
                                />  
                                {this.state.selectedJenjang === null &&     
                                <FormHelperText className="text-danger">Incorrect entry...</FormHelperText> }
                            
                            </Col>
                        </Row>
                        </FormControl>  }                  

                        <FormControl style={{marginTop: '30px'}}> 
                            <Button variant="outlined" type="submit" color="primary">Simpan</Button>
                        </FormControl>
                        
                    </form>
                    :
                    <h2 className="text-warning">On Progress gaes... Sabar dulu</h2>
                    }
                </div>
            </div>
        )
    }

    handleAlert() {
        return(
            <Collapse in={this.state.showAlert} style={{marginBottom: '13px'}}>
                <Alert severity="error"
                    action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => this.setState({showAlert: false})}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                    }
                >
                    {this.state.alertMessage}
                </Alert>
            </Collapse>

        )
    }

}

export default AccountForm;